<template>
  <div class="page-form">
    <div class="form">
      <div class="insure-title"><span>保单查询</span></div>
      <el-form ref="userForm" :model="userForm" :rules="userRules">
        <el-form-item prop="name">
          <el-input v-model="userForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item prop="cert">
          <el-input
            v-model="userForm.cert"
            placeholder="请输入证件号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input
            v-model="userForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="verifyCode">
          <el-input
            v-model="userForm.verifyCode"
            placeholder="请输入短信验证码"
          ></el-input>
          <div
            @click="getCode"
            :class="['code-button', validaCodeSure && 'active-btn']"
          >
            <span>{{
              leftTime ? `${leftTime}s后重新获取` : "获取验证码"
            }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div
        @click="submit"
        :class="['bottom-button', validaFormSure && 'active-btn']"
      >
        <span>立即查询</span>
      </div>
    </div>
  </div>
</template>

<script>
import { sendZRBXVerifyCode, queryVerifToken } from "@/api/insideJobManage";
export default {
  name: "QueryForm",
  data() {
    const validateName = (rule, value, callback) => {
      if (!this.nameReg.test(value)) {
        callback(new Error(`${value}姓名格式不正确!`));
      } else {
        callback();
      }
    };
    const validatemobile = (rule, value, callback) => {
      if (!this.mobileReg.test(value)) {
        callback(new Error(`${value}手机号格式不正确!`));
      } else {
        callback();
      }
    };
    return {
      time: 60 * 1000,
      leftTime: 0,
      ticker: null,
      nameReg:
        // eslint-disable-next-line no-useless-escape
        /(^([A-Za-z])((?!.*?\-\-)(?!.*?\ \ )[A-Za-z- ]{4,38})([A-Za-z])$)|(^([\u4E00-\u9FA5])((?!.*?\·\·)[\u4E00-\u9FA5·]{0,18})([\u4E00-\u9FA5])$)/,
      mobileReg: /^[1]([2-9])[0-9]{9}$/,
      userForm: {
        name: "",
        mobile: "",
        cert: "",
        verifyCode: "",
      },
      userRules: {
        cert: [{ required: true, message: "请输入证件号!", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入验证码!", trigger: "blur" },
        ],
        name: [{ required: true, validator: validateName, trigger: "blur" }],
        mobile: [
          { required: true, validator: validatemobile, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    validaCodeSure() {
      return (
        this.mobileReg.test(this.userForm.mobile) &&
        this.nameReg.test(this.userForm.name) &&
        this.userForm.cert
      );
    },
    validaFormSure() {
      return this.validaCodeSure && this.userForm.verifyCode;
    },
  },
  created() {
    sessionStorage.removeItem("token");
  },
  methods: {
    async getCode() {
      if (this.ticker || !this.validaCodeSure) {
        return;
      }
      const endTime = Date.now() + this.time;
      const count = () => {
        let now = Date.now();
        const diff = endTime - now;

        if (diff >= 0) {
          this.leftTime = (diff / 1000).toFixed(0);
          this.ticker = requestAnimationFrame(count);
        } else {
          this.leftTime = 0;
          this.ticker = null;
        }
      };
      count();
      const res = await sendZRBXVerifyCode({
        mobile: this.userForm.mobile,
      });
      console.log(res);
    },
    async submit() {
      if (!this.validaFormSure) {
        return;
      }
      const params = Object.assign(this.userForm, {channelNo:"8093322e7b2c11eba6d67cd30aeb1984"})
      const res = await queryVerifToken(this.userForm);
      // eslint-disable-next-line no-debugger
      // debugger
      if (res.data.code === 10000) {
        sessionStorage.setItem("token", res.data.data);
        this.$emit("state-change", "1");
      } else {
        this.$message(res.data.msg || "接口错误");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-form {
  display: flex;
  justify-content: center;
  width: 100%;
  .form {
    width: 460px;
    height: 408px;
    margin: 48px 0;
    background: #f8f8f8;
    // opacity: 0.7;
    border: 1px solid #f1f1f1;
    padding-left: 52px;
    padding-right: 68px;
    ::v-deep .el-form-item {
      margin-bottom: 16px;
    }
    ::v-deep .el-form-item__error {
      color: #f04134;
    }
    ::v-deep .el-form-item__content {
      display: flex;
    }
    // ::v-deep .el-form-item__error {
    //   position: absolute;
    //   padding-top: 0;
    //   top: 100%;
    //   left: 0;
    //   width: 100%;
    //   z-index: 2;
    //   background: #ffe6e5;
    //   border-radius: 2px;
    //   height: 30px;
    //   border: 1px solid #fe7b28;
    //   font-size: 12px;
    //   font-family: PingFangSC-Regular, PingFang SC;
    //   font-weight: 400;
    //   color: #333333;
    //   line-height: 30px;
    //   &::before {
    //     content: "—";
    //     display: inline-block;
    //     overflow: hidden;
    //     width: 10px;
    //     height: 10px;
    //     font-size: 10px;
    //     line-height: 8px;
    //     margin-left: 10px;
    //     transform: translateY(2px);
    //     margin-right: 6px;
    //     color: white;
    //     font-weight: 500;
    //     background-color: #fe7b28;
    //     border: 2px solid #fe7b28;
    //     border-radius: 50%;
    //   }
    // }

    .code-button {
      width: 120px;
      height: 40px;
      background: #ebebeb;
      color: #333333;
      border-radius: 4px;
      border: 1px solid #f5f5f5;
      display: flex;
      /* padding-left: 15px; */
      margin-left: 10px;
      align-items: center;
      justify-content: center;
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .insure-title {
      height: 20px;
      font-size: 20px;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
      margin-top: 40px;
      text-align: center;
      margin-bottom: 30px;
    }
    .bottom-button {
      width: 340px;
      height: 40px;
      background: #ebebeb;
      color: #333333;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      span {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .active-btn {
      background: #fe7b28;
      color: #ffffff;
      cursor: pointer;
    }
    ::v-deep .el-form-item.is-error .el-input__inner,
    .el-form-item.is-error .el-input__inner:focus,
    .el-form-item.is-error .el-textarea__inner,
    .el-form-item.is-error .el-textarea__inner:focus {
      border-color: #f04134;
    }
  }
}
</style>
